var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "detailCanvas",
      staticClass: "detailContent canvas-box",
      attrs: { id: "detailCanvas" },
    },
    [
      _c("div", { staticClass: "title" }, [
        _c(
          "div",
          { staticClass: "title-name" },
          [
            _vm._v(_vm._s(_vm.$t("data.payout_details")) + " "),
            _c(
              "el-tag",
              {
                staticClass: "pay-status tag-custom",
                attrs: {
                  type: _vm.getPOTransactionStatusType(
                    _vm.merchantInfo.po_trans_status
                  ),
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.getPOTransactionStatusMap(
                        _vm.merchantInfo.po_trans_status
                      )
                    )
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "detail-download-container" }, [
        _c("div", { staticClass: "total" }, [
          _c("div", { staticClass: "total-item" }, [
            _c("div", { staticClass: "total-title" }, [
              _vm._v(_vm._s(_vm.$t("data.paid")) + ":"),
            ]),
            _c("div", { staticClass: "total-num " }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$store.getters.currency) +
                  " " +
                  _vm._s(
                    _vm._f("toDivideWithDot")(_vm.merchantInfo.po_trans_amount)
                  )
              ),
            ]),
          ]),
          _c("div", { staticClass: "total-item" }, [
            _c("div", { staticClass: "total-title" }, [
              _vm._v(_vm._s(_vm.$t("data.fee")) + ":"),
            ]),
            _c("div", { staticClass: "total-num" }, [
              _vm._v(
                _vm._s(_vm.$store.getters.currency) +
                  " " +
                  _vm._s(_vm._f("toDivideWithDot")(_vm.merchantInfo.fee_split))
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "section-title mb-12 mt-12" }, [
          _vm._v(" " + _vm._s(_vm.$t("data.timeline")) + " "),
        ]),
        _c("div", { staticClass: "line-bottom-1px" }),
        _c("div", { staticClass: "item" }, [
          _c("span", { staticClass: "item-left content-blue" }, [
            _vm._v(" " + _vm._s(_vm.$t("merchantAccount.create_time"))),
          ]),
          _c("span", { staticClass: "content-gray" }, [
            _vm._v(
              " " + _vm._s(_vm.merchantInfo.transaction_create_time) + " "
            ),
          ]),
        ]),
        _c("div", { staticClass: "item" }, [
          _c("span", { staticClass: "item-left content-blue" }, [
            _vm._v(_vm._s(_vm.$t("merchantAccount.complete_time"))),
          ]),
          _c("span", { staticClass: "content-gray" }, [
            _vm._v(_vm._s(_vm.merchantInfo.transaction_return_time)),
          ]),
        ]),
        _c("div", { staticClass: "section-title mb-12 mt-36" }, [
          _vm._v(" " + _vm._s(_vm.$t("data.description")) + " "),
        ]),
        _c("div", { staticClass: "line-bottom-1px" }),
        _c("div", { staticClass: "item" }, [
          _c("span", { staticClass: "item-left content-blue" }, [
            _vm._v(_vm._s(_vm.$t("merchantAccount.transaction_id"))),
          ]),
          _c("span", { staticClass: "content-gray" }, [
            _vm._v(_vm._s(_vm.merchantInfo.transaction_id)),
          ]),
        ]),
        _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "item-left content-blue" }, [
            _vm._v(_vm._s(_vm.$t("customerService.remitting_bank")) + "："),
          ]),
          _c("div", { staticClass: "content-gray" }, [
            _vm._v(_vm._s(_vm.merchantInfo.sender_bank_name)),
          ]),
        ]),
        _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "item-left content-blue" }, [
            _vm._v(_vm._s(_vm.$t("customerService.remittance_account")) + "："),
          ]),
          _c("div", { staticClass: "content-gray" }, [
            _vm._v(
              _vm._s(
                _vm._f("strAesDecryptAndAsterisk")(
                  _vm.merchantInfo.sender_bank_account
                )
              )
            ),
          ]),
        ]),
        _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "item-left content-blue" }, [
            _vm._v(_vm._s(_vm.$t("merchantAccount.recipient_name")) + "："),
          ]),
          _c("div", { staticClass: "content-gray" }, [
            _vm._v(
              _vm._s(
                _vm._f("strAesDecryptAndAsterisk")(
                  _vm.merchantInfo.recipient_name
                )
              )
            ),
          ]),
        ]),
        _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "item-left content-blue" }, [
            _vm._v(_vm._s(_vm.$t("merchantAccount.recipient_mobile")) + "："),
          ]),
          _c("div", { staticClass: "content-gray" }, [
            _vm._v(_vm._s(_vm.merchantInfo.recipient_mobile)),
          ]),
        ]),
        _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "item-left content-blue" }, [
            _vm._v(_vm._s(_vm.$t("merchantAccount.recipient_channel")) + "："),
          ]),
          _c("div", { staticClass: "content-gray" }, [
            _vm._v(_vm._s(_vm.merchantInfo.recipient_channel)),
          ]),
        ]),
        _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "item-left content-blue" }, [
            _vm._v(_vm._s(_vm.$t("merchantAccount.recipient_account")) + "："),
          ]),
          _c("div", { staticClass: "content-gray" }, [
            _vm._v(
              _vm._s(
                _vm._f("strAesDecryptAndAsterisk")(
                  _vm.merchantInfo.recipient_account
                )
              )
            ),
          ]),
        ]),
        _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "item-left content-blue" }, [
            _vm._v(_vm._s(_vm.$t("data.remark")) + "："),
          ]),
          _c("div", { staticClass: "content-gray" }, [
            _vm._v(_vm._s(_vm.merchantInfo.product_name)),
          ]),
        ]),
        _c("div", { staticClass: "download-time mt-48" }, [
          _vm._v(
            _vm._s(_vm.$t("data.download_time")) +
              ": " +
              _vm._s(_vm._f("parseTime")(Date.now()))
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }